/* eslint-disable*/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DtpPanel } from 'dtp-react-components';
import { Grid, SimpleGrid } from '../../../components/index';
import * as listUtils from '../../../utils/listsSelect';

class InfoPagamentoGRU extends React.Component {
textoDestaque = texto => (
  (<span style={{ fontWeight: '600', marginLeft: '10px' }}>{texto}</span>)
)

compararDatas = (a, b) => {
  if (moment(a.dataVencimento, 'DD/MM/YYYY').toDate() < moment(b.dataVencimento, 'DD/MM/YYYY').toDate()) {
    return -1;
  }
  if (moment(a.dataVencimento, 'DD/MM/YYYY').toDate() > moment(b.dataVencimento, 'DD/MM/YYYY').toDate()) {
    return 1;
  }
  return 0;
};

ordenarLista = (lista) => {
  return lista.sort(this.compararDatas);
};

buscaGruPelaData = (data) => {
  const datas = this.props.estadoFormulario.infoPagamento.grusTO.filter(gru => (
    gru.dataVencimento === data
  ));

  return datas;
}

buscaRegistroComMaiorDataVencimento = () => {
  const datas = Math.max(...this.props.estadoFormulario.infoPagamento.grusTO.map((gru) => {
    const dateString = gru.dataVencimento;
    const dateParts = dateString.split('/');

    const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    return dateObject;
  }));
  return this.buscaGruPelaData(new Date(datas).toLocaleDateString());
}

buscaTipoSituacaoGru = (situacao) => {
  const buscaTipoSituacao = listUtils.tipoSituacaoGRUControlePagamento;
  const situacaoFormatada = listUtils.getObject(buscaTipoSituacao, situacao).label;

  return situacaoFormatada;
}

render() {
  const rowStyle = {
    marginBottom: '10px',
    fontSize: '16px',
  };

  const rowStyleGuias = {
    marginTop: '20px',
    marginBottom: '10px',
    fontSize: '16px',
  };
  /* const rowStyleGuiasVencidasNossoNumero = {
    marginTop: '20px',
    marginBottom: '10px',
    fontSize: '16px',
    textAlign: 'left',
  }; */
  /* const rowStyleGuiasVencidas = {
    marginTop: '20px',
    marginBottom: '10px',
    marginLeft: '20px',
    marginRight: '15px',
    fontSize: '16px',
    textAlign: 'left',
  }; */

  return (
    <DtpPanel title="Informações do Pagamento GRU">
      {this.buscaRegistroComMaiorDataVencimento().filter(gru =>
      moment(gru.dataVencimento, 'DD/MM/YYYY').toDate() >= moment(new Date().toLocaleDateString(), 'DD/MM/YYYY').toDate()).map(element => (
        <div>
          <div className="row" style={rowStyle}>
            <SimpleGrid>
              <Grid cols="6 6 6 6">
                <span>{this.textoDestaque('Guia de recolhimento (GRU): ')}{element.idGruNossoNumero}</span>
              </Grid>
              <Grid cols="6 6 6 6">
                <span>{this.textoDestaque('gerada em: ')}{element.dataCriacao}</span>
              </Grid>
            </SimpleGrid>
          </div>
          <div className="row" style={rowStyle}>
            <SimpleGrid>
              <Grid cols="6 6 6 6">
                <span>{this.textoDestaque('Vencimento: ')}{element.dataVencimento}</span>
              </Grid>
              <Grid cols="6 6 6 6">
                <span>{this.textoDestaque('Situação: ')}{this.buscaTipoSituacaoGru(element.situacao)}</span>
              </Grid>
            </SimpleGrid>
          </div>
        </div>))
      }
      <div className="row" style={rowStyleGuias}>
        <SimpleGrid>
          <Grid cols="12 12 12 12">
            {this.props.estadoFormulario.infoPagamento.grusTO && this.props.estadoFormulario.infoPagamento.grusTO.length > 0 ?
              <span>{this.textoDestaque('Guias vencidas')}</span>
          :
              <span>{this.textoDestaque('Sem guias vencidas')}</span>
            }
          </Grid>
        </SimpleGrid>
      </div>
      {this.ordenarLista(this.props.estadoFormulario.infoPagamento.grusTO).filter(gru =>
        moment(gru.dataVencimento, 'DD/MM/YYYY').toDate() < moment(new Date().toLocaleDateString(), 'DD/MM/YYYY').toDate()).map(element => (
          <div className="row" style={rowStyleGuias}>
            <SimpleGrid>
              <Grid cols="12 12 12 12">
                {this.textoDestaque('GRU: ')}<span>{element.idGruNossoNumero}</span>
                {this.textoDestaque('gerada em: ')}<span>{element.dataCriacao}</span>
                {this.textoDestaque('vencimento: ')}<span>{element.dataVencimento}</span>
              </Grid>
            </SimpleGrid>
          </div>))
          }
    </DtpPanel>
  );
}
}

InfoPagamentoGRU.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default InfoPagamentoGRU;



// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/templates/infoPagamentoGRU.jsx